import React, { useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { Box, Typography, CircularProgress } from '@material-ui/core';
import {
  MainContainer,
  MainContainerTitle,
  CustomButton,
  CustomSeparator,
} from '../../styles';
import { MainContainerFormBody } from './styles';
import ItemCreationForm from './components/ItemCreationForm';
import PageChanger from './components/PageChanger';
import usePageStore from '../../../../store/pageStore';
import useConfigsStore from '../../../../store/configsStore';

export default function ItemsCreationStep({ handleFormSubmit }) {

  //!
  const devolutionPageConfigs = useConfigsStore(
    (state) => state.devolutionPageConfigs,
  );
  const manualOrderItems = usePageStore((state) => state.manualOrderItems);
  const selectedManualItem = usePageStore((state) => state.selectedManualItem);
  const setNextSelectedManualItem = usePageStore(
    (state) => state.setNextSelectedManualItem,
  );
  const setPreviousSelectedManualItem = usePageStore(
    (state) => state.setPreviousSelectedManualItem,
  );
  const setCurrentManualItem = usePageStore(
    (state) => state.setCurrentManualItem,
  );
  const isOrderBeingCreated = usePageStore(
    (state) => state.isOrderBeingCreated,
  );
  const { control, formState, handleSubmit, reset } = useForm({
    mode: 'onBlur',
  });
  /**
   * This hooks combination (useWatch and useEffect) is made for storing
   * form data to a second state element that stores all created items.
   * This is necessary because we can switch between item pages.
   * The component is build as one single form, but it local state (from useForm)
   * gets reseted to the data of a given item.
   * That way we have a state that will store all items data and use the useForm validation
   * to the items forms.
   */
  const formDataSubscription = useWatch({ control });
  useEffect(() => {
    setCurrentManualItem(selectedManualItem, formDataSubscription);
  }, [formDataSubscription]);

  useEffect(() => {
    // If we are creating a new item, empty the form
    if (selectedManualItem === manualOrderItems.length) {
      reset({
        itemName: '',
        quantity: '',
        price: '',
        category: '',
        reason: '',
        resolution: '',
      });
    } else {
      reset(manualOrderItems[selectedManualItem]);
    }
  }, [selectedManualItem]);

  const primaryColor = devolutionPageConfigs?.primaryColor;
  const secondaryColor = devolutionPageConfigs?.secondaryColor || '#ffffff';
  const fontColor = devolutionPageConfigs?.fontColor || '#000000';
  const fontColorSecondary =
    devolutionPageConfigs?.fontColorSecondary || '#000000';
  const fontFamily =
    devolutionPageConfigs?.fontFamily || 'helvetica, sans-serif';
  return (
    <MainContainer backgroundcolor={secondaryColor}>
      <MainContainerTitle padding="0px">
        <Typography variant="h5">
          <Box
            sx={{
              fontWeight: 'bold',
              color: fontColor,
              fontFamily,
            }}
          >
            Adicione os itens do pedido
          </Box>
        </Typography>
        <CustomSeparator />
        <Typography
          style={{
            color: fontColor,
            fontFamily,
          }}
        >
          Entre com os detalhes dos itens do seu pedido
        </Typography>
      </MainContainerTitle>
      <MainContainerFormBody>
        <ItemCreationForm
          useFormProps={{
            control,
            handleSubmit,
            formState,
          }}
        />
        <PageChanger
          selectedItem={selectedManualItem + 1}
          totalItems={manualOrderItems?.length || 0}
          onPageForward={() => {
            if (selectedManualItem < manualOrderItems?.length - 1) {
              setNextSelectedManualItem();
            }
          }}
          onPageBackward={() => {
            if (selectedManualItem > 0) {
              setPreviousSelectedManualItem();
            }
          }}
          onNewItemCreated={() => {
            setNextSelectedManualItem();
          }}
          isCurrentFormValid={formState.isValid}
        />
      </MainContainerFormBody>
      <CustomButton
        color={primaryColor}
        onClick={formState.isValid ? handleFormSubmit : null}
      >
        {isOrderBeingCreated ? (
          <CircularProgress
            style={{
              color: fontColorSecondary,
            }}
          />
        ) : (
          <Typography
            style={{
              color: fontColorSecondary,
              fontFamily,
            }}
          >
            Criar Pedido
          </Typography>
        )}
      </CustomButton>
    </MainContainer>
  );
}
